import { detectUserRegion } from '@common/core/utils/detectUserRegion'

import { getUserRegionalData } from '../regional-user'
import type { InitializeRegionalInput, InitializeRegionalResult } from '../types'
import { getUserIdentities } from '../user'
import { hasRegionalIdentityForRegion } from '../utils/hasRegionalIdentityForRegion'
import { resolveKnownRegionalData } from '../utils/resolveKnownRegionalData'
import { resolveRegionalIdentityForRegion } from '../utils/resolveRegionalIdentityForRegion'

import { addUserRegionalDataAndIdentity } from './add-user-regional-data-and-identity'

export async function initializeUserRegionalData(input: InitializeRegionalInput): Promise<InitializeRegionalResult> {
  try {
    const region = detectUserRegion()
    const [regionalDataResult, identitiesResult] = await Promise.allSettled([
      getUserRegionalData(),
      getUserIdentities(),
    ])

    const fetchedRegionalData = regionalDataResult.status === 'fulfilled' ? regionalDataResult.value : null
    const fetchFailed = regionalDataResult.status === 'rejected'

    if (fetchFailed) {
      console.error('Failed to fetch user regional data:', regionalDataResult.reason)
    }

    const identities = identitiesResult.status === 'fulfilled' ? identitiesResult.value : []
    const knownRegionalData = resolveKnownRegionalData(fetchedRegionalData, input.currentUser?.regionalData)
    const hasIdentity = hasRegionalIdentityForRegion(identities, region)

    if (!knownRegionalData || !hasIdentity) {
      return addUserRegionalDataAndIdentity(input, region, knownRegionalData)
    }

    const regionalIdentity = resolveRegionalIdentityForRegion(identities, region)
    return { regionalData: knownRegionalData, regionalIdentity }
  } catch (error) {
    console.error('Failed to initialize user regional data:', error)
    return { regionalData: null, regionalIdentity: null }
  }
}
